import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Admin Sign In | 1907 Insurance Group" description="Secure sign-in for site administration." />
      <section className="py-20 md:py-28" data-testid="admin-login-page">
        <div className="container-site max-w-md">
          <form onSubmit={onSubmit} className="rounded-2xl border border-navy-100 bg-white p-8 shadow-lg" data-testid="admin-login-form">
            <h1 className="text-3xl tracking-tight">Site Administration</h1>
            <p className="mt-2 text-mutedink">Sign in to update site content and settings.</p>
            <div className="mt-6 space-y-4">
              <div>
                <label className="field-label" htmlFor="al-email">Email</label>
                <input id="al-email" type="email" className="field-input" autoComplete="username" value={email}
                  onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
              </div>
              <div>
                <label className="field-label" htmlFor="al-pass">Password</label>
                <input id="al-pass" type="password" className="field-input" autoComplete="current-password" value={password}
                  onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
              </div>
              {error && <p className="text-sm font-semibold text-red-700" role="alert" data-testid="admin-login-error">{error}</p>}
              <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="admin-login-button">
                {loading ? "Signing in…" : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
